import Formsy from 'formsy-react'
import { withTranslate } from '@i18n/utils'
import featureToggles from 'shared/featureToggles'
import { getPlateRegex } from 'shared/utils'

import ErrorMessage from '@components/ErrorMessage'
import Button from '@components/Button'
import FormsyInput from '@components/Textfield/withFormsy'

const VehicleForm = ({
    submitVehicle,
    setFormValues,
    formValues,
    translate: t,
    isLoading,
    error,
    countryStateComponent,
    isSubmitButtonDisplayed,
    handleOnValid,
    handleOnInvalid,
    formRef,
}) => {
    const [isFormValid, setIsFormValid] = React.useState(false)

    const handleFormValid = React.useCallback(() => {
        handleOnValid ? handleOnValid() : setIsFormValid(true)
    }, [])

    const handleFormInvalid = React.useCallback(() => {
        handleOnInvalid ? handleOnInvalid() : setIsFormValid(false)
    }, [])

    const onChangeHandler = event => {
        const { value, name } = event.target

        if (setFormValues)
            setFormValues({
                ...formValues,
                [name]: value,
            })
    }

    return (
        <Formsy onSubmit={submitVehicle} onValid={handleFormValid} onInvalid={handleFormInvalid} ref={formRef}>
            <FormsyInput
                className="mb-3"
                name="tag"
                required
                value={formValues ? formValues.tag : ''}
                placeholder={t('dashboard.label.licence.plate')}
                validationErrors={{
                    isAlphanumeric: t('dashboard.label.licence.plate.invalid'),
                    matchRegexp: t('dashboard.label.licence.plate.invalid.format'),
                    isDefaultRequiredValue: t('input.required.error.message'),
                }}
                validations={{
                    isAlphanumeric: true,
                    matchRegexp: getPlateRegex(),
                }}
                onChange={onChangeHandler}
            />
            <FormsyInput
                className="mb-3"
                required
                value={formValues ? formValues.make : ''}
                name="make"
                placeholder={t('dashboard.vehicles.make.label')}
                validationError={t('input.required.error.message')}
                onChange={onChangeHandler}
                maxLength="20"
            />
            <FormsyInput
                className="mb-3"
                required
                value={formValues ? formValues.model : ''}
                name="model"
                placeholder={t('dashboard.vehicles.model.label')}
                validationError={t('input.required.error.message')}
                onChange={onChangeHandler}
                maxLength="20"
            />
            <FormsyInput
                className="mb-3"
                required
                name="color"
                value={formValues ? formValues.color : ''}
                placeholder={t('dashboard.vehicles.color.label')}
                validationError={t('input.required.error.message')}
                onChange={onChangeHandler}
                maxLength="20"
            />
            {featureToggles.caPurchaseFlow && countryStateComponent()}
            {isSubmitButtonDisplayed && (
                <Button isLoading={isLoading} disabled={isLoading || !isFormValid}>
                    <T>dashboard.vehicles.add.btn.label</T>
                </Button>
            )}
            {error && <ErrorMessage className="vehicle-error" messages={[error]} />}
        </Formsy>
    )
}

export default compose(withTranslate)(VehicleForm)
